export const API_ENDPOINTS = {
  REGISTER: 'user/register',
  CONFIG: 'config/initialConfig',
  GET_INVOICE: 'invoice/list',
  POST_INVOICE: 'invoice/update-transaction-detail',
  MAIL_DOCUMENT: 'invoice/send-mail',
  CHECKOUT: 'invoice/checkout',
  TRANSACTION_INFO: 'pay/info',
  USER: 'user/me',
  RETRY_PAYMENT: 'invoice/retry-payment',
  UNIFIED_CHECKOUT: 'payment/initiate',
  UNIFIED_CHECKOUT_COMPLETE: 'payment/complete',
};
